import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Outlet } from "react-router-dom";
import { css } from "@emotion/react";
export const MinimalFormLayout = () => {
    return (_jsx("div", { css: css `
        max-width: 640px;
        padding: 24px 24px 60px;
        margin: 0 auto;
      `, children: _jsx(Outlet, {}) }));
};
